import React from 'react';
import { Wrapper, Row, Col, Links } from './styles';
import { SectionTitle, TagLink } from 'core/styles';

import PropTypes from 'prop-types';

const Tags = ({ tags, categories }) => (
	<Wrapper>
		<Row>
			<Col>
				<SectionTitle>Tags</SectionTitle>
				<Links>
					{tags && tags.map(tag =>
						<TagLink title={tag.name} href={tag.url} key={tag.id}>
							{tag.name}
						</TagLink>
					)}
				</Links>
			</Col>
			<Col>
				<SectionTitle>Related Categories</SectionTitle>
				<Links>
					{categories && categories.map(tag =>
						<TagLink title={tag.name} href={tag.url} key={tag.id}>
							{tag.name}
						</TagLink>
					)}
				</Links>
			</Col>
		</Row>
	</Wrapper>
);

const TagProps = PropTypes.arrayOf(PropTypes.shape({
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
})).isRequired;

Tags.propTypes = {
	tags: TagProps,
	categories: TagProps
};

export default Tags;
